/** What a character in the amount is, which is what decides how it moves. */
export type AmountGlyphKind = 'prefix' | 'placeholder' | 'digit'

export interface AmountGlyph {
  /** Identity across renders: what mounts is what animates in. */
  key: string
  char: string
  kind: AmountGlyphKind
}

/**
 * The amount split into the characters that animate independently. Digits are
 * keyed from the left, so appending or deleting at the right mounts or unmounts
 * exactly that character and an inserted separator shifts the rest along.
 */
export function amountGlyphs(value: string, prefix: string): AmountGlyph[] {
  const glyphs: AmountGlyph[] = []
  if (prefix) {
    glyphs.push({ key: 'prefix', char: prefix, kind: 'prefix' })
  }

  // Its own identity, not the digit zero, so typing over it unmounts it rather
  // than reading as a `0` that turned into a `1`.
  if (value === '') {
    glyphs.push({ key: 'placeholder', char: '0', kind: 'placeholder' })
    return glyphs
  }

  for (const [index, char] of [...value].entries()) {
    glyphs.push({ key: `digit-${index}`, char, kind: 'digit' })
  }
  return glyphs
}
